import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { ChangeEvent, ChangeEventHandler, useState } from 'react'
import { DebounceInput } from 'react-debounce-input'
import { useTranslation } from 'react-i18next'

import Client from '../../Customer/Client/Client'
import { ICustomer } from '../interfaces/ICustomer'

import Result from './Result/Result'
import style from './style.scss'

interface IProps {
  onSelected: (customer: ICustomer) => void
  onDeselected: () => void
  withInvoiceInformation?: boolean
}

const Search = ({
  onSelected,
  onDeselected,
  withInvoiceInformation = false,
}: IProps) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  const [customers, setCustomers] = useState<ICustomer[]>([])
  const [showResults, setShowResults] = useState<boolean>(false)

  const searchCustomer: ChangeEventHandler<HTMLInputElement> = (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    const searchString = event.target.value
    setSearch(searchString)

    Client.search(searchString, withInvoiceInformation).then(customerArray => {
      setCustomers(customerArray)
      setShowResults(true)
    })
  }

  const selectCustomer = (customer: ICustomer) => {
    onSelected(customer)
  }

  const deleteCustomer = () => {
    setCustomers([])
    setSearch('')
    onDeselected()
  }

  const onBlur = () => {
    setTimeout(() => setShowResults(false), 200)
  }

  return (
    <div className={style.search}>
      <FontAwesomeIcon icon={'search'} className={style.icon} />
      <DebounceInput
        minLength={2}
        debounceTimeout={300}
        className={style.input}
        type="search"
        onChange={searchCustomer}
        value={search}
        placeholder={t('Search customer')}
        onBlur={onBlur}
        onFocus={() => setShowResults(search.length > 0)}
      />
      {showResults ? (
        <div className={style.results}>
          {customers.map((customer: ICustomer, index: number) => {
            return (
              <Result
                key={index}
                onSelected={() => selectCustomer(customer)}
                customer={customer}
              />
            )
          })}
        </div>
      ) : null}
    </div>
  )
}

export default Search
